import { SimpleInput, SimpleInputProps } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

type TextInput = Pick<
  SimpleInputProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'value'
>;

export const TextInput = forwardRef<HTMLInputElement, TextInput>((props, ref) => (
  <SimpleInput ref={ref} size="sm" {...props} />
));
